import { useState, useEffect } from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";
import { PlayCircleOutlined } from "@ant-design/icons";

function Scenarios() {
  const [scenarios, setScenarios] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://api.projectrere.org/Scenario/GetAll"
      );
      setScenarios(response.data.scenarios);
    };
    fetchData();
  }, []);
  console.log(scenarios);
  return (
    <main>
      <header>
        <h1>Scenarios</h1>
        <p>
          On this screen, the scenarios defined in the simulation are listed and
          the statistics of these scenarios can be examined.
        </p>
      </header>
      <section className="scenarios">
        <div className="wrapper">
          <div className="cards">
            {scenarios.map((scenario) => {
              return (
                <NavLink
                  className="card"
                  to={`/scenarios/${scenario.id}`}
                >
                  <PlayCircleOutlined className="icon" />
                  <div className="card-body">
                    <p className="card-title">{scenario.title}</p>
                    <p className="card-desc">{scenario.desc}</p>
                  </div>
                </NavLink>
              );
            })}
          </div>
          {/* <List
            pagination={("both", "center")}
            dataSource={scenarios}
            renderItem={(item, index) => (
              <List.Item className="list-item">
                <List.Item.Meta
                  title={
                    <NavLink
                      to={`/scenarios/${item.id}`}
                    >
                      {item.title}
                    </NavLink>
                  }
                  description={item.desc}
                />
              </List.Item>
            )}
          /> */}
        </div>
      </section>
    </main>
  );
}

export default Scenarios;
